import React from 'react';
import { LabelText } from '../LabelText';
import { InternalTextProps } from '../InternalText';

export function Label({
  disabled = false,
  htmlFor,
  id,
  label,
  overflow,
  required = false,
}: {
  disabled?: boolean;
  htmlFor?: string;
  id?: string;
  label?: React.ReactNode;
  overflow?: InternalTextProps['overflow'];
  required?: boolean;
}) {
  if (!label) {
    return null;
  }

  return (
    <label
      // legacy.min.css has several CSS rules that target the label tag
      css={{ lineHeight: 'normal', margin: 0 }}
      htmlFor={htmlFor}
      id={id}
    >
      <LabelText disabled={disabled} overflow={overflow} required={required}>
        {label}
      </LabelText>
    </label>
  );
}
